<template lang="pug">
    v-card
        v-breadcrumbs.ml-3(:items='items' divider='/')
</template>

<script>
/* Bread-Crumb component
    1:static breadCrumb. (through a prop called 'linkBreadCrumb we pass a array with links )
*/
export default {
    name: 'bread-crumb',
    props: {
        linkBreadCrumb:{
            type:Array,
            required:true,
        }
    },
    data: function(){
        return {}
    },
    computed: {
        items(){
            if(this.linkBreadCrumb.length>0){
                return this.linkBreadCrumb
            }
            else{
                //Implement wit vue-router. 
            }
        }
    },
    methods: {
        // -- UI Modification
        // -- Data fetching
        // -- Data handling and transformations
        // -- Validations and Error handling
        // -- Other functions
        // -- Vuex mappings
    },
    // watch: {},
    // components: {},
    // mixins: [],
    // filters: {},
    // -- Lifecycle Methods
    // -- End Lifecycle Methods
}
</script>

<style lang="scss">
    
</style>